import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './auth/auth.guard';
import { ChannelPartnersComponent } from './dashboard/channel-partners/channel-partners.component';
import { DelearsComponent } from './dashboard/channel-partners/delears/delears.component';
import { SubdelearsComponent } from './dashboard/channel-partners/subdelears/subdelears.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InventoryComponent } from './dashboard/inventory/inventory.component';
import { ListComponent } from './dashboard/inventory/list/list.component';
import { SettingsComponent } from './dashboard/inventory/settings/settings.component';
import { TemplateComponent } from './dashboard/invoice/template/template.component';
import { LeadComponent } from './dashboard/leads/lead/lead.component';
import { LeadsComponent } from './dashboard/leads/leads.component';
import { ManageLeadsComponent } from './dashboard/leads/manage-leads/manage-leads.component';
import { CreateCustomerComponent } from './dashboard/sales/create-customer/create-customer.component';
import { CustomersComponent } from './dashboard/sales/customers/customers.component';
import { DetailsComponent } from './dashboard/sales/details/details.component';
import { PaymentsComponent } from './dashboard/sales/payments/payments.component';
import { SalesComponent } from './dashboard/sales/sales.component';
import { StatusComponent } from './dashboard/sales/status/status.component';
import { UsersComponent } from './dashboard/users/users.component';
import { LayoutComponent } from './layout/layout.component';
import { ProjectComponent } from './project/project.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children:[
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'inventory',
        component: InventoryComponent,
        children:[
          {
            path: '',
            component: ListComponent
          },
          {
            path: 'settings',
            component: SettingsComponent
          }
        ]
      },
      {
        path: 'channel-partners',
        component: ChannelPartnersComponent,
        children:[
          {
            path: '',
            component: DelearsComponent
          },
          {
            path: 'subdelear',
            component: SubdelearsComponent
          }
        ]
      },
      {
        path: 'sales',
        component: SalesComponent,
        children:[
          {
            path: 'create-customer',
            component: CreateCustomerComponent
          },
          {
            path: 'customers',
            component: CustomersComponent
          },
          {
            path: 'details',
            component: DetailsComponent
          },
          {
            path: 'payments',
            component: PaymentsComponent
          }
        ]
      },
      {
        path: 'leads',
        component: LeadsComponent,
        children:[
          {
            path: '',
            component: LeadComponent
          },
          {
            path: 'manage',
            component: ManageLeadsComponent
          }
        ]
      },
      {
        path: 'invoice',
        component: InventoryComponent,
        children:[
          {
            path: '',
            component: TemplateComponent
          }
        ]
      },
      {
        path: 'user',
        component: UsersComponent
      }
    ]
  },
  {
    path: 'projects',
    component: ProjectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: AuthComponent
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
